import { CustomFilter } from 'app/ComponentLibrary/Filter';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { TabTitle } from '../../PerformanceReport';

interface IFilterProps {
  selectedValue: any;
  defaultValues: any;
  title: TabTitle;
  onReset: () => void;
  chips: any;
  filterSpec: any;
}

const Filters = (props: IFilterProps) => {
  const { defaultValues, selectedValue, filterSpec } = props;
  const { reset } = useFormContext();
  const [fields, setFields] = useState(filterSpec);

  useEffect(() => {
    reset(selectedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue]);

  const onResetForm = () => {
    props.onReset();
    reset(defaultValues);
  };

  return <CustomFilter fields={fields} justifyContent={'flex-start'} version2 onResetForm={onResetForm} />;
};

export default Filters;
